import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { cladColor, cladColorImgs } from "./defaults";

const useExtCladSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const exteriorCladColor = useStore((state) => state.quote.exteriorCladColor);
  const customCladColor = useStore((state) => state.quote.customCladColor);
  const originalExteriorCladColor = React.useRef(exteriorCladColor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (value.length <= 20) {
      addToQuote({ customCladColor: value }, "customCladColor");

      if (findRequired("Custom Clad Color"))
        removeRequired("Custom Clad Color");
    }
  };

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    addToQuote(
      { exteriorCladColor: !checked ? label : "", customCladColor: "" },
      "exteriorCladColor",
    );

    if (!checked && findRequired("Exterior Clad Color"))
      removeRequired("Exterior Clad Color");
  };

  const customCladChosen =
    exteriorCladColor === "Custom Color (upcharge applies)";

  const variant = (label: string) =>
    label === exteriorCladColor ? "filled" : "outlined";

  const checkMark = (label: string) => label === exteriorCladColor;

  const cladColorImg = exteriorCladColor
    ? cladColorImgs.find((img) => img.label === exteriorCladColor)
    : null;

  //only allowing clear anodized values for orders that currently have clear anodized selected
  //quotes could possibly have clear anodized if an order was updated to a quote
  const cladColorOptions =
    originalExteriorCladColor.current === "Clear Anodized"
      ? [
          ...cladColor.slice(0,4),
          {
            id: 6,
            type: "exteriorCladColor",
            label: "Clear Anodized",
          },
          ...cladColor.slice(4),
        ]
      : cladColor ?? [];

  return {
    handleChange,
    customCladColor,
    handleClick,
    customCladChosen,
    variant,
    checkMark,
    cladColorImg,
    cladColorOptions,
  };
};

export default useExtCladSelector;
